import request from '@/utils/request'

export function getUserdownload(current, size) {
    return request({
        url: `api/personalUser/download`,
        // url: "api/meeting/searchMeeting",
        method: 'get',
        // data
        params: {
            'current': current,
            'size': size,

        }
    })
}
export function getUserDocumentAll(auditState, current, size) {
    return request({
        url: `api/personalUser/uploadDetails`,
        // url: "api/meeting/searchMeeting",
        method: 'post',
        // data
        params: {
            'auditState': auditState,
            'current': current,
            'size': size,

        }
    })
}
export function delDetails(id) {
    return request({
        url: `api/personalUser/delDocument`,
        // url: "api/meeting/searchMeeting",
        method: 'delete',
        // data
        params: {
            'id': id,
        }
    })
}